<template>
  <div class="class-tab" :class="{ small: isSmall }">
    <div
      v-for="(item, index) in tabList"
      :key="item.classId"
      class="tab"
      :class="{ active: index === activeIndex }"
      @click="$emit('set-active-index', index)"
    >
      <img :src="item.img" />
      <div class="name">{{ item.className }}</div>
    </div>
  </div>
</template>
<script>
import { ScrollAnimate } from '@/utils/utils'

const scrollAnimate = new ScrollAnimate({
  direction: 'HORIZONTAL'
})

export default {
  props: {
    tabList: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    activeIndex: {
      handler: function (newval) {
        // 选中的标签居中
        this.$nextTick(() => {
          scrollAnimate.scrollTo({
            el: this.$el,
            start: this.$el.scrollLeft,
            end: this.calScrollLeft(newval)
          })
        })
      },
      immediate: true
    }
  },
  methods: {
    // 计算tab滚动距离
    calScrollLeft(toIndex) {
      const screenWidth = window.innerWidth
      let target
      const singleWidth = Math.floor(screenWidth * 0.2)
      const leftPosX = 2 // (index < this.tabList.length / 2)? 0.5: 2.8; // 据左边栏的身位
      target = Math.floor((toIndex - leftPosX) * singleWidth)
      target = Math.max(0, target)
      target = Math.min(this.tabList.length * singleWidth - screenWidth, target)
      return target
    }
  }
}
</script>
<style lang="scss" scoped>
.class-tab {
  display: flex;

  height: 1.96rem;

  background-color: #f5f5f5;

  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  border-top-left-radius: 0.4rem;
  border-top-right-radius: 0.4rem;
  overflow-x: auto;
  overflow-y: hidden;

  transition: height 0.3s;

  .tab {
    display: flex;

    width: 1.2rem;
    height: 1.48rem;
    margin-left: 0.18rem;

    flex: none;

    flex-direction: column;
    justify-content: center;
    align-items: center;

    transition: height 0.3s;
    & > img {
      transform: translate3d(0, 0, 0);

      width: 0.8rem;
      height: 0.8rem;
      margin-bottom: 0.14rem;

      transition: height 0.5s;
    }
    .name {
      font-size: 0.24rem;
      color: #262626;
    }

    &.active {
      position: relative;

      background-color: #fff;
      border-radius: 0.24rem;
      &:after {
        display: block;

        position: absolute;
        bottom: -14px;
        left: 50%;
        transform: translateX(-50%);

        border: 7px solid transparent;
        border-top: 7px solid #fff;

        content: '';
      }
    }
  }

  &.small {
    height: 0.88rem;
    .tab {
      width: auto;
      height: 100%;
      padding: 0 0.18rem;
      & > img {
        width: 0;

        height: 0;
      }
      .name {
        font-size: 0.28rem;
      }
      &.active {
        background-color: transparent;
        border-radius: 0;

        color: #f03100;
        &:after {
          bottom: 0;

          width: 0.36rem;
          height: 0.06rem;

          background-color: #fe2a42;
          border-radius: 0.06rem;
          border: none;
        }
      }
    }
  }
}
</style>
